import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";
import AdminWorkspaceInvoices from "@/components/admin/admin-workspace-invoices";

const AdminWorkspaceInvoicesPage = (): JSX.Element => {
	const { workspaceId } = Route.useParams();
	return <AdminWorkspaceInvoices workspaceId={workspaceId} />;
};

export const Route = createFileRoute("/_app/admin/workspaces/$workspaceId/invoices")({
	component: AdminWorkspaceInvoicesPage,
});
